import axios from 'axios'
import store from '@/store'

const developmentServer = false
const development = process.env.NODE_ENV !== 'production'

const apiEndpoint = development
  ? 'http://smartsolar.local'
  : developmentServer
    ? 'https://dev.takesmart.co/api'
    : 'https://smartsolar.takesmart.co/api'

export default {
  signin (username, password) {
    return axios.post(apiEndpoint + '/auth/signin', {
      username: username,
      password: password,
    }, null)
  },
  signout () {
    return axios.get(apiEndpoint + '/auth/signout', {
      headers: {
        authorization: 'Bearer ' + store.getters.getToken
      }
    })
  }
}
